var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("px-5 py-3 text-sm font-bold leading-normal text-white rounded border outline-none cursor-pointer " + _vm.color),attrs:{"type":_vm.type},on:{"click":_vm.click}},[_vm._t("default",[_vm._v("Submit")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }